module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "frontmatter Acknowledgments",
    attrs: {
      "id": "rw-frontmatter-Acknowledgments_70540-057174972"
    }
  }, [_c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_70540-354412824"
    }
  }, [_c('h1', {
    attrs: {
      "id": "rw-h1_70540-347364843"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781455522866_tableofcontents",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _c('p', {
    staticClass: "firstpara",
    attrs: {
      "id": "rw-p_70540-125576150"
    }
  }, [_vm._v("Michele, I’ve said it before, but it bears repeating. Your insights are absolutely brilliant and make an incredible difference in my books. Thank you for everything.")]), _c('p', {
    attrs: {
      "id": "rw-p_70540-351012398"
    }
  }, [_vm._v("Lucienne, thank you so much for all of your advice, for answering questions, and most of all for your enthusiasm. I’m so fortunate to have you for an agent.")]), _c('p', {
    attrs: {
      "id": "rw-p_70540-856077249"
    }
  }, [_vm._v("Many thanks once again to Kati for being the best personal assistant ever. Thank you so very much!")]), _c('p', {
    attrs: {
      "id": "rw-p_70540-670354779"
    }
  }, [_vm._v("Also, lots of thanks and hugs to my street team partner Kieran Kramer and to all of the Regency Rockstars. You are all fabulous. xoxoxo")]), _c('p', {
    attrs: {
      "id": "rw-p_70540-988890703"
    }
  }, [_vm._v("To all of the readers, thank you so much for reading my books and for the kind e-mails letting me know how much you enjoy the stories I create. I wish you all hours of happy reading.")]), _c('div', {
    staticClass: "block",
    attrs: {
      "id": "rw-block-letter_70540-401714291"
    }
  }, [_c('p', {
    staticClass: "signature-fm",
    attrs: {
      "id": "rw-signature_70540-181446685"
    }
  }, [_vm._v("Cheers!")]), _c('p', {
    staticClass: "signature-continued-fm",
    attrs: {
      "id": "rw-signature_70540-436492982"
    }
  }, [_vm._v("Vicky")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31cd930b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781455522866_acknowledgments.vue
// module id = 69
// module chunks = 0